import BaseModel from "../base/BaseModel.model";
import PorposalBudgetItem from './porposalBudgetItem.model';
import PorposalBudgetSubItemInstitutionDetail from './porposalBudgetSubItemInstitutionDetail.model';

export default class PorposalBudgetSubItem extends BaseModel {
  public porposalBudgetItemId?: number | null;
  public budgetSubItem?: string | null;
  public unit?: string | null;
  public month?: number | null;
  public unitCost?: number | null;
  public porposalBudgetSubItemInstitutionDetails: Array<PorposalBudgetSubItemInstitutionDetail>  = [];
  public porposalBudgetItem:PorposalBudgetItem = new PorposalBudgetItem(); 
  
  public currentInstitution:any = 0;

  constructor() {
    super();
    this.init();
  }
  init() {
    this.currentInstitution = 0;
    this.porposalBudgetItemId = 0;
    this.budgetSubItem = null;
    this.unit = null;
    this.month = 0;
    this.unitCost = 0;
    this.porposalBudgetSubItemInstitutionDetails = [];
    this.porposalBudgetItem = new PorposalBudgetItem();
  }
}
